import apiClient from "./client";
import type {
  DisasterStatusesResponse,
  GetDisasterStatusesParams,
} from "../types/disaster";

export const getDisasterStatuses = async (
  displayId: string,
  params: GetDisasterStatusesParams
): Promise<DisasterStatusesResponse> => {
  const { data } = await apiClient.get<DisasterStatusesResponse>(
    `/disaster-statuses/${displayId}`,
    {
      params: {
        display_code: params.display_code,
        name: params.name,
        pref: params.pref,
        m_branch_id: params.m_branch_id,
        m_customer_id: params.m_customer_id,
        latest_alive: params.latest_alive,
        latest_sales: params.latest_sales,
        latest_authori: params.latest_authori,
        is_input: params.is_input,
        is_damage: params.is_damage,
        order: params.order,
        sort: params.sort,
        page: params.page,
        limit: params.limit,
      },
    }
  );
  return data;
};
